module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"button":{"viewOther":"View other"},"otherName":"Other Name","dialog":{"notCompletedTask":{"title":"Complete task","text":"You should finish <b>\\"Complete data editing\\"</b> task\\n before you can update this information.","button":"View tasks"}}}}')
  delete Component.options._Ctor
}
